import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { LocaleService, SolLocale } from '../services/locale.service';

export function provideSolLocale(bundleNames: string[], languages?: SolLocale[]): EnvironmentProviders {
  return provideAppInitializer(() => {
    const localeService = inject(LocaleService);
    return localeService.initialize(bundleNames, languages);
  });
}
